import http from '@/vendor/axios'

export function upload (files) {
  const formData = new FormData()

  files.forEach(file => formData.append('ufile', file))

  const url = '/web/binary/upload_file'
  return http.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
